import api from "./api";
import {iniciarRequisicao, logout} from "../helpers/index.js";
import {STATUS_HTTP} from "./statusHTTP";

export const buscarDadosGestaoComprador = async (params) => {
  const url = `/indicadores/gestao-do-comprador`;

  const config = {
    params,
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.dados;
  }

  logout();
}

export const buscarDepartamentosFiltroStatusProduto = async (params) => {
  const url = `/status-produtos/filtros/departamentos`;

  const config = {
    params,
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamentos;
  }

  logout();
}

export const buscarFornecedoresFiltroStatusProduto = async (params) => {
  const url = `/status-produtos/filtros/fornecedores`;

  const config = {
    params,
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.fornecedores;
  }

  logout();
}

export const buscarCompradoresFiltroStatusProduto = async (params) => {
  const url = `/status-produtos/filtros/compradores`;

  const config = {
    params,
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.compradores;
  }

  logout();
}

class IndicadoresAPI {

  async getAnos(headers) {
    const response = await api.get("/getAnos", { headers });
    return response;
  }

  async getIndicadorEstoqueMensal(headers, params) {
    const response = await api.get("/indicador_estoque_mensal_grupo", { headers, params });
    return response;
  }

  async getStatusEstoqueMensal(headers, params) {
    const response = await api.get("/get_status_estoque_mensal_grupo", { headers, params });
    return response;
  }

  async getAnaliseFinanceiro(headers, params) {
    const response = await api.get("/get_analise_financeiro", { headers, params });
    return response;
  }

  async getStatusFinanceiro(headers, params) {
    const response = await api.get("/get_status_financeiro", { headers, params });
    return response;
  }

  async getStatusFiltroProduto(headers, params) {
    const response = await api.get("/get_status_filtro_produto", { headers, params });
    return response;
  }

  async getAnosMeses(headers, params) {
    const response = await api.get("/get_anos_meses", { headers, params });
    return response;
  }

  async getDadosStatusProduto(headers, params) {
    const response = await api.get("/get_dados_status_produto", { headers, params });
    return response;
  }

  async getCompradoresEmFornecedores(headers) {
    const response = await api.get("/get_compradores_em_fornecedores", { headers });
    return response;
  }

  async getDescricoesFamiliaProduto(headers, params) {
    const response = await api.get("/get_descricoes_familia_produto", { headers, params });
    return response;
  }

  async getDadosPerdaVendaRuptura(headers, params) {
    const response = await api.get("/get_dados_perda_venda_ruptura", { headers, params });
    return response;
  }

  async getDadosPerdaVendaRupturaGrafico(headers, data) {
    return await api.post("indicadores/perda-venda-por-ruptura/grafico", data, {headers});
  }

  async getFornecedoresPorCompradorSegmento(headers, params) {
    const response = await api.get("/get_fornecedores_comprador_segmento", { headers, params });
    return response;
  }

  async getDadosFiltrosPercepcaoCompra(headers, params) {
    const response = await api.get("/get_dados_filtros_percepcao_compra", { headers, params });
    return response;
  }

  // async getIndicadorPercepcaoCompra(headers, params) {
  //   const response = await api.get("indicadores/get_indicador_percepcao_compra", { headers, params });
  //   return response;
  // }

  async getDadosFiltrosStatusProdutos(headers, params) {
    const response = await api.get("/get_dados_filtros_status_produtos", { headers, params });
    return response;
  }

  async getIndicadorStatusProdutos(headers, params) {
    const response = await api.get("/get_indicador_status_produtos", { headers, params });
    return response;
  }

  async getDialogIndicadorStatusProdutos(params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: 'post',
      url: '/get_dialog_indicador_status_produtos',
      headers,
      data: params
    });

    return response;
  }

  async getDadosFiltrosIndicadorStatusProdutos(headers, params) {
    const response = await api.get("/get_dados_filtros_indicador_status_produtos", { headers, params });
    return response;
  }

  async getIndicadorStatusProdutosGrid(headers, params) {
    const response = await api.get("/get_indicador_status_produtos_grid", { headers, params });
    return response;
  }
}

export default new IndicadoresAPI();
